import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Home from "./pages/Home";
import Agricultural from "./pages/Agricultural";
import Cardboard from "./pages/Cardboard";
import Polystyrene from "./pages/Polystyrene";
import SecureDestruction from "./pages/SecureDestruction";
import FarmReservoirs from "./pages/FarmReservoirs";
import Aggregates from "./pages/Aggregates";
import GetAQuote from "./pages/GetAQuote";
import Privacy from "./pages/Privacy";
import NotFound from "./pages/NotFound";

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/agricultural-recycling" element={<Agricultural />} />
          <Route path="/cardboard-recycling" element={<Cardboard />} />
          <Route path="/polystyrene-recycling" element={<Polystyrene />} />
          <Route path="/secure-destruction" element={<SecureDestruction />} />
          <Route path="/farm-reservoirs" element={<FarmReservoirs />} />
          <Route path="/aggregates" element={<Aggregates />} />
          <Route path="/get-a-quote" element={<GetAQuote />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
